import { Translation } from '../types';

export const bg: Translation = {
  common: {
    loading: 'Зареждане...',
    error: 'Грешка',
    cancel: 'Отказ',
    save: 'Запиши',
    close: 'Затвори',
    search: 'Търсене',
    reload: 'Презареди',
    logout: 'Изход',
    dashboard: 'Табло',
    products: 'Продукти',
    settings: 'Настройки',
    language: 'Език',
    businessHours: 'Работно време',
    back: 'Назад',
    selectAll: 'Избери всички',
    deselectAll: 'Отмени избора',
    success: 'Успех',
    selected: 'Избрани',
    confirm: 'Потвърди',
    required: 'Задължително',
    requiredMarker: '*',
    previous: 'Предишен',
    next: 'Следващ',
    allRightsReserved: 'Всички права запазени.',
  },
  auth: {
    login: 'Вход',
    email: 'Имейл адрес',
    password: 'Парола',
    loginButton: 'Вход',
    loggingIn: 'Влизане...',
    loginSuccess: 'Успешен вход',
    loginError: 'Невалиден имейл или парола',
    invalidEmail: 'Моля, въведете валиден имейл адрес',
    requiredFields: 'Моля, въведете имейл и парола',
    demoAccount: 'Демо акаунт:',
    loginDescription: 'Въведете данните си за вход',
    welcomeMessage: 'Добре дошли в системата за бизнес поръчки',
    // Registration
    register: 'Регистрация',
    createAccount: 'Създай акаунт',
    confirmPassword: 'Потвърди паролата',
    passwordRequirements: 'Паролата трябва да е поне 8 знака и да съдържа главна буква, малка буква, цифра и специален знак',
    passwordsDoNotMatch: 'Паролите не съвпадат',
    registrationSuccess: 'Регистрацията е успешна',
    registrationDescription: 'Регистрирайте бизнес акаунт',
    alreadyHaveAccount: 'Вече имате акаунт?',
    signIn: 'Влезте',
    dontHaveAccount: "Нямате акаунт?",
    creatingAccount: 'Създаване на акаунт...',
    registrationNote: 'Бележка:',
    registrationNotePoints: {
      erpLinking: 'Ако имате съществуващ бизнес акаунт, имейлът ви ще бъде автоматично свързан',
      companyEmail: 'Моля, използвайте фирмения си имейл адрес за регистрация',
      contactSupport: 'Свържете се с поддръжката, ако имате нужда от помощ при регистрацията'
    },
    b2bUsers: 'Потребители на бизнес акаунт:',
    registeredEmail: 'Регистриран имейл адрес',
    registeredPassword: 'Парола, зададена при регистрацията',
    b2bCustomerRequired: 'Този имейл адрес не е регистриран като бизнес клиент. Моля, свържете се с отдел продажби, за да установите бизнес отношения първо.',
    b2bVerificationError: 'Не може да се потвърди статусът на бизнес клиент. Моля, свържете се с поддръжката.',
    // Password Reset
    passwordReset: 'Възстановяване на парола',
    passwordResetDescription: 'Въведете имейл адреса си, за да получите временна парола',
    getTemporaryPassword: 'Получи временна парола',
    processing: 'Обработка...',
    passwordResetComplete: 'Възстановяването на паролата приключи',
    temporaryPasswordGenerated: 'Генерирана е временна парола',
    temporaryPassword: 'Временна парола',
    backToLogin: 'Назад към вход',
    securityNotice: 'Съобщение за сигурност:',
    securityNotePoints: {
      keepSecret: 'Не споделяйте временната парола с други',
      changeAfterLogin: 'Не забравяйте да промените паролата си след вход',
      expires24Hours: 'Временната парола изтича след 24 часа'
    },
    resetNote: 'Бележка:',
    resetNotePoints: {
      registeredEmail: 'Въведете регистрирания си имейл адрес',
      passwordDisplayed: 'Временната парола ще се покаже на екрана',
      changeRequired: 'Изисква се смяна на паролата след вход'
    },
    copied: 'Копирано',
    copySuccessMessage: 'Временната парола е копирана в клипборда.',
    forgotPassword: 'Забравена парола?',
    // Password Reset Email Request
    sendResetLink: 'Изпрати линк за възстановяване',
    sendingEmail: 'Изпращане на имейл...',
    emailSent: 'Имейлът е изпратен',
    emailSentMessage: 'Ако този имейл адрес съществува в нашата система, скоро ще получите линк за възстановяване на паролата.',
    emailNotSent: 'Имейлът не е изпратен',
    emailSentInfo: 'Проверете входящата си кутия и папката за спам',
    checkEmail: 'Проверете имейла си',
    emailInstructions: 'Инструкциите за възстановяване на паролата са изпратени',
    nextSteps: 'Следващи стъпки:',
    nextStepsList: {
      checkInbox: 'Проверете входящата си кутия и папката за спам',
      clickLink: 'Кликнете върху линка за възстановяване в имейла',
      linkExpires: 'Линкът изтича след 24 часа',
      contactSupport: 'Свържете се с поддръжката, ако не получите имейла',
      rateLimitInfo: 'Ограничено до 3 заявки на час'
    },
    // Password Reset Completion
    resetLinkSent: 'Линкът за възстановяване е изпратен',
    resetSuccess: 'Паролата е успешно възстановена',
    passwordUpdated: 'Паролата е обновена',
    passwordUpdateMessage: 'Паролата ви беше успешно обновена. Вече можете да влезете с новата си парола.',
    loginWithNewPassword: 'Вход с нова парола',
    // Reset Token Page
    resetToken: 'Възстановяване на парола',
    invalidToken: 'Невалиден токън за възстановяване',
    expiredToken: 'Токънът за възстановяване е изтекъл',
    tokenValid: 'Токънът за възстановяване е валиден',
    newPassword: 'Нова парола',
    confirmNewPassword: 'Потвърди новата парола',
    updatePassword: 'Обнови паролата',
    updatingPassword: 'Обновяване на паролата...',
    passwordMismatch: 'Паролите не съвпадат',
    resetInstructions: 'Въведете новата си парола, за да завършите възстановяването',
  },
  accountInfo: {
    title: 'Информация за акаунта',
    loading: 'Зареждане на информация за акаунта...',
    error: 'Грешка',
    errorMessage: 'Неуспешно извличане на информация за акаунта',
    back: 'Назад',
    basicInfo: 'Основна информация',
    name: 'Име',
    email: 'Имейл адрес',
    contactId: 'Knitido клиентски ID',
    contactNumber: 'Номер за контакт',
    noInfo: 'Няма информация',
    companyInfo: 'Информация за фирмата',
    company: 'Име на фирмата',
    position: 'Длъжност',
    vatId: 'ДДС номер (VAT ID)',
    billingAddress: 'Адрес за фактуриране',
    deliveryAddress: 'Адрес за доставка',
    addressInfo: 'Информация за адреса',
    billingDescription: 'Адрес за фактури и договорни документи',
    deliveryDescription: 'Стандартен адрес за доставка на продукти',
    sameAsBilling: '※ Същият като адреса за фактуриране',
    sameAsDelivery: '※ Същият като адреса за доставка',
    companyName: 'Име на фирмата',
    contactPerson: 'Лице за контакт',
    address: 'Адрес',
    phoneNumber: 'Телефонен номер',
    billingUsage: 'Използва се като дестинация за фактури, договори и други важни документи',
    deliveryUsage: 'Използва се като стандартен адрес за доставка на поръчани продукти',
    alsoUsedForDelivery: 'Използва се и като дестинация за доставка',
    accountType: 'Тип акаунт',
    addressId: 'ID на адрес',
    // Address editing functionality
    edit: 'Редактирай',
    editDeliveryAddress: 'Редактирай адреса за доставка',
    editDeliveryDescription: 'Актуализирайте информацията за адреса за доставка',
    newDeliveryAddress: 'Добави нов адрес за доставка',
    newDeliveryDescription: 'Въведете детайлите за новия адрес за доставка',
    noDeliveryAddress: 'Няма конфигуриран адрес за доставка',
    success: 'Успех',
    addressUpdated: 'Адресът за доставка е обновен успешно',
    updateError: 'Неуспешно обновяване на адреса за доставка',
    requiredFields: 'Моля, попълнете всички задължителни полета',
    firstName: 'Име',
    lastName: 'Фамилия',
    streetAddress: 'Улица и номер',
    streetAddress2: 'Улица и номер 2',
    city: 'Град',
    country: 'Държава',
    selectCountry: 'Изберете държава...',
    searchCountry: 'Търсене на държава...',
    noCountryFound: 'Няма намерена държава.',
    postalCode: 'Пощенски код',
    companyNamePlaceholder: 'Въведете име на фирмата',
    firstNamePlaceholder: 'Име',
    lastNamePlaceholder: 'Фамилия',
    streetAddressPlaceholder: 'Въведете улица и номер',
    streetAddress2Placeholder: 'Апартамент, офис и др.',
    cityPlaceholder: 'Въведете град',
    postalCodePlaceholder: 'Въведете пощенски код',
    billingNotEditable: 'Адресът за фактуриране не може да бъде редактиран.',
    billingContactSupport: 'Свържете се с поддръжката за промени.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} адреса за доставка',
    noDeliveryAddresses: 'Няма регистрирани адреси за доставка',
    defaultAddress: 'По подразбиране',
    selectDeliveryAddress: 'Изберете адрес за доставка',
    addNewAddress: 'Добави нов адрес',
    editAddress: 'Редактирай адрес',
    deleteAddress: 'Изтрий адрес',
    confirmDelete: 'Потвърди изтриването',
    confirmDeleteMessage: 'Сигурни ли сте, че искате да изтриете този адрес? Това действие не може да бъде отменено.',
    addressAddedSuccess: 'Адресът за доставка е добавен',
    addressDeletedSuccess: 'Адресът за доставка е изтрит',
    deleteError: 'Неуспешно изтриване на адрес за доставка',
    saving: 'Записване...',
    cancel: 'Отказ',
    saveChanges: 'Запиши промените',
    selectedDeliveryAddress: 'Избран адрес за доставка',
  },
  dashboard: {
    title: 'Бизнес партньор',
    subtitle: 'Система за поръчка на продукти',
    welcome: 'Добре дошли,',
    welcomeMessage: 'Добре дошли в системата за поръчки на бизнес партньори. Тук можете да поръчвате продукти.',
    productCatalog: 'Продуктов каталог',
    productCatalogDesc: 'Разгледайте и поръчайте налични продукти',
    viewProducts: 'Виж продуктите',
    orderHistory: 'История на поръчките',
    orderHistoryDesc: 'Преглед на минали поръчки (очаквайте скоро)',
    accountSettings: 'Настройки на акаунта',
    accountSettingsDesc: 'Управление на информацията за акаунта (очаквайте скоро)',
    comingSoon: 'Очаквайте скоро',
    infoTitle: 'За използването',
    orderingInfo: 'Поръчка на продукти',
    orderingDesc: 'Изберете продукти от каталога и посочете размер и цвят. Налична е информация за наличности в реално време.',
    supportInfo: 'Поддръжка',
    supportDesc: 'Ако имате въпроси, моля свържете се с нас.',
    viewOrderHistory: 'Виж история на поръчките',
    viewOrders: 'Виж поръчките',
    accountInfo: 'Информация за акаунта',
    accountInfoDesc: 'Вижте детайлите на акаунта си',
    viewDetails: 'Виж детайли',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Понеделник-Петък 9:00 - 15:00 CET',
    bulkImportDesc: 'Импортиране на поръчки от Excel/CSV файлове',
    importOrders: 'Импорт на поръчки',
  },
  products: {
    title: 'Списък с продукти',
    subtitle: 'Бизнес партньор',
    searchPlaceholder: 'Търсене по име на продукт или SKU...',
    productId: 'ID на продукт',
    addToCart: 'Добави в количката',
    selectVariation: 'Избери вариация',
    price: 'Цена',
    priceNetNotice: 'Всички цени са нетни',
    stock: 'Наличност',
    color: 'Цвят',
    newProducts: 'Нови продукти',
    newProductBadge: 'НОВО',
    size: 'Размер',
    quantity: 'Количество',
    total: 'Общо',
    cart: 'Количка',
    checkout: 'Поръчка',
    csvMode: 'CSV Бърз режим',
    csvInfo: 'Продуктовите данни са извлечени от CSV данни',
    csvUploadDate: 'Дата на качване на CSV:',
    stockNote: '※ Информацията за наличността се извлича при избор на продуктови вариации',
    noProducts: 'Няма намерени продукти',
    noProductsDesc: 'Променете критериите за търсене или качете CSV файл за по-бърза работа.',
    retry: 'Опитай отново',
    pagination: 'артикула',
    variations: 'вариации',
    stockFetchError: 'Грешка при извличане на наличност',
    stockFetchFailed: 'Неуспешно извличане на наличност',
    stockFetchFailedDesc: 'Не може да се извлече информация за наличността. Ще се покаже наличност от CSV.',
    stockFetched: 'Информацията за наличността е извлечена',
    totalStock: 'Обща наличност',
    noStockAll: 'Всички вариации са с нулева наличност',
    noStockData: 'Не са върнати данни за наличност',
    stockFetchErrorDesc: 'Възникна грешка при извличане на информация за наличността',
    selectionError: 'Грешка при избора',
    enterQuantity: 'Моля, въведете количество',
    addedToCart: 'Добавено в количката',
    typesAdded: ' видове продукти добавени',
    addToCartError: 'Грешка при добавяне в кошница',
    addToCartErrorDesc: 'Моля, опитайте отново',
    loadingStock: 'Зареждане на информация за наличност',
    csvDataInfo: 'Показване на информация от CSV данни (не са актуални наличности)',
    invalidDataFormat: 'Форматът на продуктовите данни е невалиден',
    loadFailed: 'Неуспешно зареждане на продуктови данни',
    csvUploadComplete: 'Качването на CSV е завършено',
    csvLoadedDesc: ' продуктови данни заредени. Информацията за наличността ще бъде извлечена при избор на продукти.',
    searchTitle: 'Търсене на продукти',
    loadingProducts: 'Зареждане на продуктови данни',
    noProductsCsv: 'Няма намерени продукти в CSV данните. Моля, променете критериите за търсене.',
    paginationDisplay: ' показани',
    previous: 'Предишен',
    next: 'Следващ',
    selectionSummary: 'Обобщение на избора',
    selectedQuantity: 'Избрано количество',
    items: ' артикула',
    viewDetails: 'Виж детайли',
    productImage: 'Изображение на продукта',
    correspondingVariations: 'Съответстващи вариации',
    clickToEnlarge: 'Кликнете за уголемяване',
    productIdLabel: 'ID на продукт',
    colorLabel: 'Цвят',
    filterByCategory: 'Филтриране по категория',
    allProducts: 'Всички продукти',
    applyFilters: 'Приложи филтри',
    clearFilters: 'Изчисти филтри',
    filters: 'Филтри',
    clearAll: 'Изчисти всички',
  },
  categories: {
    category_21: 'Чорапи с пръсти',
    category_23: 'Без категория',
    category_24: 'Бельо',
    category_29: 'B2B Продукти',
  },
  productDetail: {
    title: 'Детайли за продукта',
    backToProducts: 'Назад към продуктите',
    productNotFound: 'Продуктът не е намерен',
    productNotFoundDesc: 'Посоченият продукт не съществува или е бил изтрит.',
    loading: 'Зареждане на продукт...',
    imageLoadError: 'Неуспешно зареждане на изображения',
    noImages: 'Няма налични изображения',
    productDescription: 'Описание на продукта',
    colors: 'Цветове',
    sizes: 'Размери',
    colorCount: 'цвята',
    sizeCount: 'размера',
    variationCount: 'вариации',
    selectVariation: 'Избери вариации',
    descriptionLanguageNote: '※ Описанията на продуктите са налични само на английски или немски',
  },
  colors: {
    schwarz: 'Черно',
    weiß: 'Бяло',
    grau: 'Сиво',
    rot: 'Червено',
    blau: 'Синьо',
    grün: 'Зелено',
    gelb: 'Жълто',
    rosa: 'Розово',
    lila: 'Лилаво',
    braun: 'Кафяво',
    orange: 'Оранжево',
    beige: 'Бежово',
    navy: 'Тъмносиньо (Navy)',
    dunkelblau: 'Тъмносиньо',
    hellblau: 'Светлосиньо',
    dunkelgrau: 'Тъмносиво',
    hellgrau: 'Светлосиво',
    bordeaux: 'Бордо',
    türkis: 'Тюркоаз',
    khaki: 'Каки',
    mint: 'Мента',
    violett: 'Виолетово',
    anthrazit: 'Антрацит',
    blaugrau: 'Синьо-сиво',
    burgunderrot: 'Бургундско червено',
    elfenbein: 'Слонова кост',
    karminrot: 'Карминено червено',
    neongrün: 'Неоново зелено',
    gelbgrün: 'Жълто-зелено',
    pistazie: 'Фъстък',
    // English color names (used in Product ID 237 etc.)
    blue: 'Синьо',
    ivory: 'Слонова кост',
    green: 'Зелено',
    gold: 'Златно',
    red: 'Червено',
  },
  checkout: {
    title: 'Поръчка',
    cartReview: 'Преглед на поръчката',
    orderSummary: 'Обобщение на поръчката',
    shippingInfo: 'Информация за доставка',
    billingInfo: 'Информация за плащане',
    orderNotes: 'Бележки към поръчката',
    orderNotesPlaceholder: 'Специални изисквания или бележки...',
    contactPerson: 'Лице за контакт',
    phoneNumber: 'Телефонен номер',
    email: 'Имейл адрес',
    company: 'Фирма',
    address: 'Адрес',
    city: 'Град',
    postalCode: 'Пощенски код',
    country: 'Държава',
    deliveryDate: 'Дата на доставка',
    urgentDelivery: 'Експресна доставка (3-5 работни дни)',
    standardDelivery: 'Стандартна доставка (7-10 работни дни)',
    placeOrder: 'Потвърди поръчката',
    backToCart: 'Назад към избор на продукти',
    requiredField: 'Задължително поле',
    orderTotal: 'Общо поръчка',
    subtotal: 'Междинна сума',
    priceNetNotice: 'Всички цени са нетни',
    stockReservationNotice: 'Резервацията на наличност ще бъде направена след потвърждение на поръчката.',
    stockCheckError: 'Грешка при проверка на наличност',
    stockCheckErrorDesc: 'Възникна грешка при проверката на наличността. Моля, опитайте отново.',
    shipping: 'Доставка',
    shippingCost: 'Цена за доставка',
    tax: 'Данък',
    orderSuccess: 'Поръчката е успешна',
    orderSuccessMessage: 'Вашата поръчка беше изпратена успешно. Номер на поръчка: {orderNumber}',
    orderNumber: 'Номер на поръчка',
    thankYou: 'Благодарим ви за поръчката!',
    orderConfirmation: 'Вашата поръчка беше изпратена успешно.',
    orderProcessing: 'След преглед от нашия екип, ще ви изпратим потвърждение на поръчката по имейл.',
    orderProcessingMessage: 'Вашата поръчка беше изпратена успешно. След преглед от нашия екип, ще ви изпратим потвърждение на поръчката по имейл.',
    continueShopping: 'Продължи пазаруването',
    emptyCart: 'Количката ви е празна',
    emptyCartMessage: 'Моля, добавете продукти в количката, за да продължите',
    stockWarning: 'Предупреждение за наличност',
    stockWarningDesc: 'Някои артикули са с недостатъчна наличност. Моля, коригирайте количествата.',
    stockError: 'Грешка с наличността',
    stockErrorDesc: 'Има артикули с недостатъчна наличност. Моля, коригирайте количествата.',
    refreshStock: 'Обнови наличност',
    stockUpdated: 'Наличността е обновена',
    stockUpdatedDesc: 'Наличността е обновена - {changed} променени артикула',
    stockCheckDesc: 'Показват се резултати от сравнението с инвентара',
    stockOk: 'Наличност OK',
    stockShortage: 'Недостиг на наличност',
    requestedQty: 'Заявено к-во',
    currentStock: 'Текуща наличност',
    stockShortageMsg: 'Недостатъчна наличност. Моля, коригирайте количеството.',
    stockIssueWarning: 'Поръчката не може да бъде потвърдена поради проблеми с наличността.',
    stockDataMissing: 'Данните за наличност се извличат. Моля, изчакайте малко.',
    outOfStock: 'Няма наличност.',
    maxAvailable: 'Максимум',
    autoRestored: 'Количката е възстановена',
    autoRestoredDesc: 'Артикулите от последната ви сесия са възстановени',
    maxQuantityReached: 'Достигнато е максималното налично количество.',
    // ERP Contact Search
    contactSearch: 'Търсене на контакт на клиент',
    contactSearchDesc: 'Въведете имейл адреса на поръчителя, за да извлечете информация за контакт',
    emailAddress: 'Имейл адрес',
    searchButton: 'Търсене',
    searching: 'Търсене',
    contactFound: 'Контактът е намерен',
    contactNotFound: 'Контактът не е намерен',
    contactId: 'Knitido клиентски ID',
    companyName: 'Фирма',
    contactPersonLabel: 'Лице за контакт',
    addressesFound: 'Намерени адреси',
    addressType: 'Тип',
    addressBilling: 'Адрес за фактуриране',
    addressDelivery: 'Адрес за доставка',
    vatSourceCompany: 'Информация за фирмата',
    vatSourceBilling: 'Фактуриране',
    vatSourceDelivery: 'Доставка',
    addressOther: 'Друг',
    addressDetails: 'Адрес',
    loadingAddresses: 'Зареждане на информация за адрес...',
    addressRetrieved: 'Информацията за адреса е извлечена',
    addressNotFound: 'Информация за адреса не е намерена',
    addressNotFoundDesc: 'Няма регистрирана информация за адрес. Моля, въведете ръчно.',
    addressError: 'Грешка при извличане на адрес',
    addressErrorDesc: 'Неуспешно извличане на информация за адрес.',
    contactNotConfirmed: 'Контактът на клиента не е потвърден',
    contactNotConfirmedDesc: 'Моля, въведете имейл адрес и потърсете контакта.',
    searchContact: 'Търси контакт',
    inputError: 'Грешка във въвеждането',
    inputErrorDesc: 'Информацията за доставка е непълна. Моля, проверете.',
    processing: 'Обработка...',
    erpContactSearch: 'Търсене на контакт на клиент',
    contactSearchError: 'Имейл адресът не отговаря на регистриран контакт.',
    // Product Images Toggle
    showProductImages: 'Покажи изображения на продукти',
    showProductImagesDesc: 'Показване на изображения на продукти за по-добър преглед (може да увеличи времето за зареждане)',
    // System Registration Info
    systemRegistrationInfo: 'Вашата клиентска информация',
    editShippingAddress: 'Редактирай адреса за доставка',
    systemRegistrationInfoDesc: 'Вашата регистрирана бизнес информация. Моля, свържете се с вашия представител, ако трябва да актуализирате данните за фактуриране.',
    // Order Summary
    regularPrice: 'Редовна цена на едро',
    offeredPrice: 'Предложена цена',
    discount: 'Отстъпка',
    b2bCustomer: 'B2B Клиент',
    pattern: 'Модел',
    specialPriceApplied: 'Приложена специална цена',
    customerClassification: 'Класификация на клиента',
    paymentCondition: 'Условия на плащане',
    invoice: 'Фактура (NET 30)',
    prepayment: 'Предварително плащане',
    paymentMethod: 'Метод на плащане',
    invoicePayment: 'Плащане по фактура',
    estimatedSubtotal: 'Очаквана междинна сума',
    estimatedTotal: 'Очаквана обща сума',
    orderSummaryDisclaimer: 'Цените, показани тук, са приблизителни. След като получим поръчката ви, ще я прегледаме и ще ви изпратим обвързващо потвърждение на поръчката с крайните цени, разходите за доставка и данъците по имейл.',
    searchError: 'Грешка при търсене',
    searchErrorDesc: 'Възникна грешка по време на търсенето на контакт.',
    confirmDeleteItem: 'Премахни артикул',
    itemDeleted: 'Артикулът е премахнат',
    confirmDeleteItemDesc: 'Сигурни ли сте, че искате да премахнете следния артикул от количката?',
    deleteConfirm: 'Премахни',
    contactNotes: 'Бележки за контакт',
    contactNotesDesc: 'Имате ли въпроси или специални изисквания? Моля, уведомете ни (по избор)',
    contactNotesLabel: 'Съобщение',
    contactNotesPlaceholder: 'напр.: Въпроси за продукти, специални изисквания и др.',
    characters: 'знака',
    contactIdLabel: 'Knitido клиентски ID',
    companyLabel: 'Фирма',
    personLabel: 'Лице за контакт',
    emailLabel: 'Имейл',
    addressTypeLabel: 'Тип',
    destinationLabel: 'Дестинация',
    // Shipping Form
    shippingTitle: 'Информация за доставка',
    shippingDesc: 'Въведете адреса за доставка на продуктите',
    companyRequired: 'Фирма *',
    contactPersonRequired: 'Лице за контакт *',
    emailRequired: 'Имейл адрес *',
    phoneRequired: 'Телефонен номер *',
    addressRequired: 'Адрес 1 *',
    address2: 'Адрес 2 (Сграда/Стая)',
    postalCodeRequired: 'Пощенски код *',
    cityRequired: 'Град *',
    countryRequired: 'Държава *',
    selectCountry: 'Изберете държава',
    shippingMethodRequired: 'Метод на доставка *',
    selectShippingMethod: 'Изберете метод на доставка',
    urgentDeliveryOption: 'Експресна доставка (допълнителни такси)',
    deliveryNotes: 'Бележки за доставка',
    deliveryNotesPlaceholder: 'Въведете предпочитания за време на доставка или други искания',
    standardShipping: 'Стандартна доставка (3-5 работни дни)',
    expressShipping: 'Експресна доставка (1-2 работни дни)',
    overnightShipping: 'Доставка на следващия ден',
    germany: 'Германия',
    austria: 'Австрия',
    switzerland: 'Швейцария',
    japan: 'Япония',
    shippingAddressLabel: 'Адрес за доставка',
    changeDeliveryAddress: 'Промени адреса за доставка',
    selectDeliveryAddress: 'Избери адрес за доставка',
    // Shipping Cost Details
    freeShipping: 'Безплатна доставка',
    shippingError: 'Грешка',
    shippingZone: 'Зона за доставка',
    remainingForFreeShipping: 'още {amount} за безплатна доставка',
    moreForFreeShipping: 'още за безплатна доставка',
    freeShippingProgress: 'Безплатна доставка при',
    andAboveFreeShipping: 'и повече за безплатна доставка',
    freeShippingAchieved: 'Приложена безплатна доставка',
    threshold: 'и повече',
    nextShippingTier: 'Следваща отстъпка за доставка',
    moreForDiscount: 'още за',
    shippingSavings: 'спестявания от доставка',
    orderAmountThreshold: 'и повече за',
    specialRegionNotice: 'Приложен специален регион за доставка',
    defaultShippingApplied: 'Приложени стандартни тарифи за доставка',
    requestedQuantity: 'Заявено количество',
    availableQuantity: 'Налично количество',
    orderSubmitError: 'Грешка при поръчката',
    orderSubmitErrorDesc: 'Неуспешно изпращане на поръчка',
    upload: {
      title: 'Импорт на поръчка от Excel/CSV',
      description: 'Качете Excel или CSV файл с данните за вашата поръчка',
      dragDropOrClick: 'Плъзнете и пуснете файл тук или кликнете за избор',
      dropHere: 'Пуснете файла тук',
      supportedFormats: 'Поддържани формати: Excel (.xlsx, .xls) и CSV (.csv)',
      maxSize: 'Максимален размер на файла: {size} MB',
      processFile: 'Обработи файл',
      processing: 'Обработка на файл...',
      ready: 'Файлът е готов за преглед',
      readyDescription: 'Файлът ви беше успешно обработен и е готов за преглед.',
      preview: 'Покажи преглед',
      errors: {
        fileTooLarge: 'Файлът е твърде голям. Максимален размер: {size} MB',
        invalidFileType: 'Невалиден тип файл. Моля, качете Excel или CSV файл',
        uploadFailed: 'Грешка при качване на файла',
      },
    },
    // Loading messages
    loadingPage: 'Зареждане на страница...',
    loadingStock: 'Проверка на складова наличност...',
    loadingAccount: 'Зареждане на информация за акаунта...',
    loadingError: 'Възникна грешка...',
    loadingData: 'Зареждане на данни',
    // Toast messages
    addressRetrievedTitle: 'Информацията за адреса е извлечена',
    addressSetAsDelivery: ' адрес е зададен като дестинация за доставка.',
    contactFoundDesc: ' беше разпознат.'
  },
  orderHistory: {
    title: 'История на поръчките',
    searchPlaceholder: 'Търсене по номер на поръчка или SKU...',
    noOrders: 'Няма намерени поръчки',
    noOrdersFound: 'Няма намерени съвпадащи поръчки',
    startShopping: 'Виж продуктите',
    orderItems: 'Артикули в поръчката',
    viewDetails: 'Детайли',
    reorder: 'Поръчай отново',
    orderDate: 'Дата на поръчка',
    orderStatus: 'Статус',
    orderTotal: 'Общо поръчка',
    // Status translations
    statusPending: 'Чака плащане',
    statusProcessing: 'Обработва се',
    statusConfirmed: 'Потвърдена',
    statusShipped: 'Изпратена',
    statusDelivered: 'Доставена',
    statusCancelled: 'Отказана',
    statusReturned: 'Върната',
    statusRefunded: 'Възстановена сума',
    statusWarranty: 'Гаранция',
    statusExchanged: 'Заменена',
    statusRepair: 'Ремонт',
    statusUnknown: 'Неизвестен',
    statusIncomplete: 'Непълна',
    statusWaitingPayment: 'Очаква плащане',
    statusInPreparation: 'В подготовка',
    statusClearedShipping: 'Одобрена за изпращане',
    statusBeingShipped: 'В процес на изпращане',
    statusOutgoingBooked: 'Изходяща резервирана',
    statusReturn: 'Връщане',
    // Additional UI elements
    itemCount: 'артикула',
    itemCountSingular: 'артикул',
    refreshButton: 'Обнови',
    errorFetchingOrders: 'Неуспешно извличане на история на поръчките',
    // Payment status features
    paymentStatus: 'Статус на плащане',
    markAsPaid: 'Маркирай като платена',
    unmarkAsPaid: 'Премахни маркировка за плащане',
    paidOn: 'Платено на',
    paymentMarked: 'Платено',
    notPaid: 'Неплатено',
    paymentMarkedSuccess: 'Успешно маркирано като платено',
    paymentUnmarkedSuccess: 'Маркировката за плащане е премахната',
    paymentUpdateError: 'Неуспешно обновяване на статуса на плащане',
    // Payment date dialog
    paymentDateTitle: 'Въведете информация за плащане',
    paymentDateDescription: 'Въведете информация за плащане за поръчка {orderNumber}',
    paymentDateLabel: 'Дата на плащане',
    selectDate: 'Изберете дата',
    paymentDateHelp: 'Изберете датата, на която е направен банковият превод',
    paymentMethodLabel: 'Метод на плащане',
    bankTransfer: 'Банков превод',
    invoice: 'Фактура',
    otherPayment: 'Друг',
    paymentReferenceLabel: 'Име на превода / Референтен номер',
    paymentReferencePlaceholder: 'напр. Иван Иванов, Превод #12345',
    paymentReferenceHelp: 'Въведете информация, която помага за съпоставяне с банкови извлечения',
    notesLabel: 'Бележки',
    notesPlaceholder: 'Въведете допълнителна информация за плащане',
    // Filter options
    filterByPaymentStatus: 'Филтрирай по статус на плащане',
    allOrders: 'Всички поръчки',
    paidOrders: 'Платени',
    unpaidOrders: 'Неплатени',
    // Sorting options
    sortBy: 'Сортирай по',
    sortByDate: 'Дата на поръчка',
    sortByPaymentDate: 'Дата на плащане',
    sortByAmount: 'Сума',
    sortByStatus: 'Статус',
  },
  orderDetails: {
    title: 'Детайли за поръчката',
    notFound: 'Поръчката не е намерена',
    backToHistory: 'Назад към история на поръчките',
    orderDate: 'Дата на поръчка',
    orderItems: 'Артикули в поръчката',
    deliveryStatus: 'Статус на доставка',
    estimatedDelivery: 'Очаквана доставка',
    deliveredOn: 'Доставено на',
    downloadInvoice: 'Изтегли фактура',
    statusDelivered: 'Доставена',
    statusShipped: 'Изпратена',
    statusConfirmed: 'Потвърдена',
    statusCancelled: 'Отказана',
    errorFetchingDetails: 'Неуспешно извличане на детайли за поръчката',
  },
  company: {
    name: 'Бизнес партньор',
    tagline: 'Система за бизнес партньори',
    copyright: '© 2025 Система за бизнес партньори. Всички права запазени.',
  },
  footer: {
    phone: 'Телефон',
    email: 'Имейл',
    countries: {
      DE: 'Германия',
      AT: 'Австрия',
      CH: 'Швейцария',
      FR: 'Франция',
      IT: 'Италия',
      ES: 'Испания',
      NL: 'Нидерландия',
      BE: 'Белгия',
      PL: 'Полша',
      SE: 'Швеция',
      NO: 'Норвегия',
      FI: 'Финландия',
      DK: 'Дания',
      LT: 'Литва',
      LV: 'Латвия',
      EE: 'Естония',
    },
  },
  cart: {
    newCart: 'Нова количка',
    currentCart: 'Текуща количка',
    modified: 'променена',
    lastSaved: 'Последно запазена',
    unsavedChanges: 'незапазени промени',
    saveCart: 'Запиши количка',
    loadCart: 'Зареди количка',
    deleteCart: 'Изтрий количка',
    startNewCart: 'Започни нова количка',
    savedCarts: 'Запазени колички',
    cartSaved: 'Количката е запазена',
    cartDeleted: 'Количката е изтрита',
    confirmDeleteCart: 'Изтриване на количката?\n\nТова действие не може да бъде отменено.',
    confirmSwitchCart: 'Текущата количка има незапазени промени.\n\nЗареждането на друга количка ще доведе до загуба на текущите промени.\n\nПродължи?',
    confirmSwitchCartTitle: 'Смяна на количка',
    confirmNewCart: 'Текущата количка има незапазени промени.\n\nЗапочването на нова количка ще доведе до загуба на текущите промени.\n\nПродължи?',
    confirmNewCartTitle: 'Започни нова количка',
    confirmClearCart: 'Изчистване на количката?\n\n{count} артикула ще бъдат премахнати.\n\nТова действие не може да бъде отменено.',
    confirmClearCartTitle: 'Изчисти количка',
    autoSaved: 'Автоматично запазена',
    itemsWillBeRemoved: 'артикула ще бъдат премахнати',
    changesWillBeLost: 'промените ще бъдат загубени',
    continueQuestion: 'Продължи?',
    cartStatus: 'Статус на количката',
    cartName: 'Име на количката',
    cartNamePlaceholder: 'напр.: Поръчка за края на месеца',
    cartNameRequired: 'Моля, въведете име на количката',
    saveCartDescription: 'Дайте име на текущата количка и я запазете. Можете да я заредите по-късно.',
    cancelCart: 'Откажи количка',
    proceedToCheckout: 'Към плащане',
    emptyCart: 'Количката е празна',
    erpDown: 'Системата за поръчки е спряна. Моля, опитайте отново по-късно.',
    erpDegraded: 'Системата е нестабилна. Поръчките може да се провалят.',
    erpDownSaveHint: 'Запазете количката си и поръчайте, когато системата се възстанови.',
    erpSaveCart: 'Запазване на количката',
  },
  nav: {
    dashboard: 'Табло',
    products: 'Продукти',
    orderHistory: 'История на поръчките',
    account: 'Акаунт инфо',
    bulkImport: 'Масов импорт',
  },
  settings: {
    selectLanguage: 'Изберете език',
    languagePreferenceSaved: 'Предпочитанията ви ще бъдат запазени в акаунта ви за бъдещи посещения.',
  },
  reorder: {
    allItemsAdded: '{count} артикула добавени в количката',
    partialSuccess: '{added} артикула добавени. {failed} артикула не можаха да бъдат добавени',
    allItemsFailed: 'Неуспешно добавяне на артикули в количката',
    error: 'Възникна грешка при повторна поръчка',
    itemDiscontinued: '{name} ({color}/{size}) е спрян от производство',
    itemOutOfStock: '{name} ({color}/{size}) е изчерпан',
    partialStock: '{name} ({color}/{size}) само {available} налични',
    confirmReorder: 'Потвърди повторна поръчка',
    confirmReorderMessage: 'Добавяне на артикули от тази поръчка в количката?',
    addingToCart: 'Добавяне в количката...',
    checkingStock: 'Проверка на наличност...',
    checkoutTitle: 'Артикулите са добавени в количката',
    checkoutDescription: '{count} артикула бяха добавени в количката ви. Искате ли да продължите към плащане?',
  },
  bulkImport: {
    instructions: 'Как да импортирате поръчки',
    step1: 'Изтеглете файла шаблон за поръчка',
    step2: 'Попълнете данните за поръчката със SKU и количество',
    step3: 'Запишете като Excel (.xlsx) или CSV файл',
    step4: 'Качете файла чрез формата по-долу',
    step5: 'Прегледайте и потвърдете поръчката си',
    downloadTemplate: 'Изтегли шаблон',
    downloadExcelTemplate: 'Изтегли Excel шаблон',
    downloadCsvTemplate: 'Изтегли CSV шаблон',
    formatGuide: 'Ръководство за формата на файла',
    requiredColumns: 'Задължителни колони',
    skuDescription: 'Код на продукта (SKU)',
    quantityDescription: 'Количество за поръчка (положително цяло число)',
    optionalColumns: 'Опционални колони',
    notesDescription: 'Вътрешни бележки (напр. номер на поръчка, референция) - само за ваш архив',
    formatNote: 'Първият ред трябва да съдържа заглавията на колоните. Данните започват от втория ред.',
    parseSuccess: 'Успешно разчетени {count} артикула от файла',
    parseError: 'Грешка при разчитане',
    validationError: 'Грешки при валидация',
    validationErrorGuidance: 'Моля, кликнете бутона "{showPreviewButton}", за да прегледате детайлите.',
    warnings: 'Предупреждения',
    itemsParsed: 'Успешно разчетени {count} артикула:',
    andMore: '...и още {count} артикула',
    validationSummary: 'Обобщение на валидацията',
    duplicateSKUs: 'Намерени са дублиращи се SKU',
    skuFormat: 'SKU трябва да съдържа само букви, цифри и тирета',
    quantityRange: 'Количеството трябва да е между 1 и 9999',
    maxRows: 'Максимум 1000 реда са разрешени',
    rowsSkipped: '{count} реда бяха пропуснати поради грешки',
    previewTitle: 'Преглед на поръчката',
    previewDescription: 'Прегледайте и редактирайте данните за поръчката преди да продължите',
    proceedToCart: 'Добави в количката',
    // File parsing messages
    fileEmpty: 'Файлът е празен или не съдържа данни',
    fileTooManyRows: 'Файлът съдържа твърде много редове ({current}). Максимум разрешени: {max}',
    invalidRowFormat: 'Невалиден формат на реда',
    missingColumns: 'Липсват задължителни колони (SKU и Quantity)',
    missingSku: 'Липсва SKU',
    invalidSkuFormat: 'Невалиден SKU формат: "{sku}" (трябва да отговаря на шаблон: {pattern})',
    skuTooLong: 'SKU е твърде дълъг: "{sku}" (максимум 50 знака)',
    invalidQuantity: 'Невалидно количество: "{quantity}" не е число',
    quantityTooLow: 'Количеството е твърде малко: {quantity} (минимум: {min})',
    quantityTooHigh: 'Количеството е твърде голямо: {quantity} (максимум: {max})',
    notesRequired: 'Полето за бележки е задължително',
    noValidData: 'Не са намерени валидни данни. Моля, проверете формата на файла.',
    row: 'Ред {row}: {errors}',
    rowErrors: '...и още {count} грешки',
    duplicateSkuInRows: 'Дублиран SKU "{sku}" намерен в редове: {rows}',
    quantityExceedsMax: 'Ред {row}: Количеството {quantity} надвишава максимума ({max})',
    quantityBelowMin: 'Ред {row}: Количеството {quantity} е под минимума ({min})',
    // Validation messages
    unsupportedFileFormat: 'Неподдържан файлов формат. Моля, качете CSV или Excel файл.',
    csvParsingErrors: 'Възникнаха грешки при разчитане на CSV',
    failedToParseFile: 'Неуспешно разчитане на файл',
    failedToParseExcel: 'Неуспешно разчитане на Excel файл',
    failedToReadFile: 'Неуспешно четене на файл',
    unknownError: 'Възникна неизвестна грешка',
    totalRows: 'Общо редове',
    valid: 'Валидни',
    invalid: 'Невалидни',
    skipped: 'Пропуснати',
    // SKU validation
    skuValidationError: 'Грешка при валидация на SKU',
    skuValidationFailed: 'Неуспешна валидация на SKU. Можете да продължите, но някои артикули може да не са налични.',
    skuNotFound: 'SKU не е намерен в базата данни',
    skusNotFound: '{count} SKU не са намерени в базата данни',
    itemsHaveInsufficientStock: '{count} артикула имат недостатъчна наличност',
    validatingSKUs: 'Валидиране на артикули...',
    unvalidatedChanges: 'Имате невалидирани промени. Моля, валидирайте отново преди да добавите в количката.',
    revalidate: 'Валидирай отново',
    validating: 'Валидиране...',
    validationSuccess: 'Всички артикули са валидни',
    validationComplete: 'Валидацията приключи',
    validationResultSummary: 'Намерени са {errors} грешки, {warnings} предупреждения',
    // Table headers
    actions: 'Действия',
    notes: 'Бележки',
    // Status filter
    all: 'Всички',
    hasErrors: 'Има грешки',
    // Selection summary
    selected: 'избрани',
    errors: 'грешки',
    // Pagination
    page: 'Страница {current} от {total}',
    previous: 'Предишен',
    next: 'Следващ',
    noResults: 'Няма резултати.',
    // Cart integration
    noValidItems: 'Няма валидни артикули',
    allItemsHaveErrors: 'Всички артикули имат грешки при валидация. Моля, поправете ги преди да продължите.',
    dataLoadingError: 'Грешка при зареждане на данни',
    failedToLoadProductData: 'Неуспешно зареждане на продуктови данни. Моля, опитайте отново.',
    itemsAddedToCart: '{count} артикула добавени в количката',
    itemsAddedMessage: 'Добавени {count} артикула в количката',
    someSkusNotFound: '{count} SKU не можаха да бъдат намерени.',
    noItemsAdded: 'Няма добавени артикули',
    couldNotFindProducts: 'Не можаха да бъдат намерени продукти, съответстващи на SKU.',
    errorAddingToCart: 'Грешка',
    failedToAddToCart: 'Неуспешно добавяне на артикули в количката. Моля, опитайте отново.',
    addingToCart: 'Добавяне в количката...',
    // File info
    fileSelected: '{name} избран за обработка',
    fileSize: '{size} байта',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Изтегляне на шаблон',
    templateWillBeImplemented: 'Изтеглянето на шаблон ще бъде реализирано във Фаза 7',
    // Additional validation
    validationFailed: 'Валидацията е неуспешна',
    // Template download
    templateDownloaded: 'Шаблонът е изтеглен успешно',
    templateDownloadError: 'Неуспешно изтегляне на шаблон',
    // Template content
    sheetName: 'Масова поръчка',
    instructionsSheetName: 'Инструкции',
    columnDescriptions: 'Описание на колоните:',
    columnHeader: 'Колона',
    columnRequired: 'Задължително',
    columnOptional: 'Опционално',
    columnDescription: 'Описание',
    templateNotes: 'Бележки:',
    templateNote1: 'Първият ред трябва да съдържа заглавията на колоните точно както е показано',
    templateNote2: 'Данните започват от ред 2',
    templateNote3: 'SKU трябва да съответства на съществуващи продуктови кодове в системата',
    templateNote4: 'Количеството трябва да е положително цяло число между 1 и 9999',
    templateNote5: 'Максимум 1000 реда са разрешени на файл',
    templateNote6: 'Запишете във формат .xlsx или .csv',
    stockAvailabilityWarning: 'Аклуалната наличност ще бъде проверена на следващата страница за плащане.',
    outOfStock: 'Няма наличност',
    insufficientStock: 'Недостатъчна наличност: {available} налични, {requested} заявени',
  },
  orderExport: {
    export: 'Експортирай поръчка',
    exportOrder: 'Експортирай данни за поръчка',
    exportAsCSV: 'Експортирай като CSV',
    exportAsExcel: 'Експортирай като Excel',
    exportForReorder: 'Експорт за масов импорт',
    detailed: 'Пълни детайли',
    simpleFormat: 'Импорт формат',
  },
};
